import {
  computed,
  type ComputedRef,
  type Component,
  type MaybeRef,
  unref,
} from 'vue';
import type { IColumnDefinition } from '../types';
import { resolveFormatterComponent } from '../compile-template';
import {
  ItpTextFormatter,
  ItpNumberFormatter,
  ItpCheckboxFormatter,
  ItpDateFormatter,
  ItpLinkFormatter,
  ItpLockFormatter,
  ItpSelectFormatter,
  ItpTemplateFormatter,
  ItpTimeFormatter,
} from '../cell-types';

export function getDefaultFormatterByType(type: string | undefined): Component {
  switch (type) {
    case 'number':
      return ItpNumberFormatter;
    case 'date':
      return ItpDateFormatter;
    case 'time':
      return ItpTimeFormatter;
    case 'checkbox':
      return ItpCheckboxFormatter;
    case 'link':
      return ItpLinkFormatter;
    case 'lock':
      return ItpLockFormatter;
    case 'template':
      return ItpTemplateFormatter;
    case 'select':
    case 'select2':
      return ItpSelectFormatter;
    case 'textarea':
      return ItpTextFormatter;
    default:
      return ItpTextFormatter;
  }
}

export interface CellFormatterApi {
  formatter: ComputedRef<Component>;
  isCustom: ComputedRef<boolean>;
}

export function useCellFormatter(
  column: MaybeRef<IColumnDefinition>,
): CellFormatterApi {
  const resolvedCustom = computed(() =>
    resolveFormatterComponent(unref(column).formatter),
  );
  const formatter = computed<Component>(
    () => resolvedCustom.value ?? getDefaultFormatterByType(unref(column).type),
  );
  const isCustom = computed(() => !!resolvedCustom.value);
  return { formatter, isCustom };
}
